import {
  ALL_FAQ_FAIL,
  ALL_FAQ_REQUEST,
  ALL_FAQ_SUCCESS,
} from "app/utils/constants/faqConstant";

const INIT_STATE = {
  loading: false,
  error: null,
  allFaq: [],
};

export const faqReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ALL_FAQ_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_FAQ_SUCCESS:
      return {
        ...state,
        loading: false,
        allFaq: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case ALL_FAQ_FAIL:
      return {
        ...state,
        loading: false,
        allFaq: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
